import { createContext, useContext, useState, useEffect } from "react";
import { API_URL } from "./config";
import { useNavigate } from "react-router-dom";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [rolUsuari, setRolUsuari] = useState(null);
  const [usuariActiu, setUsuariActiu] = useState(null);

  // 🔹 nous camps
  const [esSuperUsuari, setEsSuperUsuari] = useState(false);
  const [NomUsuari, setNomUsuari] = useState("");
  const [profileReady, setProfileReady] = useState(false); // estat clau per no renderitzar abans d’hora

  const navigate = useNavigate();

useEffect(() => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    setProfileReady(true);
    return;
  }

  fetch(`${API_URL}/Perfil.php`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      if (!data.success) {
        // Token invàlid o caducat: netegem la sessió i tornem al login,
        // igual que quan es va introduir aquesta comprovació.
        localStorage.removeItem("authToken");
        localStorage.removeItem("empresaSeleccionada");
        navigate("/login");
        return;
      }

      // 👇 Consistència de claus (ajusta segons el que retorna el teu PHP)
      const rol          = data.rol ?? null;
      const empresaFromAPI = data.empresa ?? null;
      const idUsuari     = data.idUsuari ?? null;
      const superFlag    = (data.esSuperUsuari) ? true : false;
      const nomUsuari    = data.nomUsuari ?? "";

      setRolUsuari(rol);
      setUsuariActiu(idUsuari);
      setEsSuperUsuari(superFlag);
      setNomUsuari(nomUsuari);

      // 🔐 No “matis” l’empresa d’un superusuari amb el null del perfil
      // 1) mirem si ja n’hi havia una guardada (per reloads)
      let empresaGuardada = null;
      try {
        const raw = localStorage.getItem("empresaSeleccionada");
        if (raw) empresaGuardada = JSON.parse(raw);
      } catch {}

      if (superFlag) {
        // superusuari: conserva la selecció existent (guardada o al context)
        const preferida = empresaGuardada ?? empresaSeleccionada ?? null;
        setEmpresaSeleccionada(preferida);
      } else {
        // usuari normal: la del perfil és la font de veritat
        setEmpresaSeleccionada(empresaFromAPI);
        try {
          if (empresaFromAPI) {
            localStorage.setItem("empresaSeleccionada", JSON.stringify(empresaFromAPI));
          } else {
            localStorage.removeItem("empresaSeleccionada");
          }
        } catch {}
      }
    })
    .catch((err) => {
      console.error("Error al recuperar el perfil:", err);
      localStorage.removeItem("authToken");
      // opcional: navigate("/login");
    })
    .finally(() => {
      setProfileReady(true);
    });
// ⚠️ molt important: sense deps per evitar reexecucions en cada navigate
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


  // 🔹 helpers útils i consistents amb localStorage
  const selectEmpresa = (empresa) => {
    setEmpresaSeleccionada(empresa);
    if (empresa) {
      localStorage.setItem("empresaSeleccionada", JSON.stringify(empresa));
    } else {
      localStorage.removeItem("empresaSeleccionada");
    }
  };

  const clearSession = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("empresaSeleccionada");
    setRolUsuari(null);
    setEmpresaSeleccionada(null);
    setUsuariActiu(null);
    setEsSuperUsuari(false);
    setNomUsuari("");
    setProfileReady(false);
  };

  return (
    <UserContext.Provider
      value={{
        // estat
        empresaSeleccionada,
        setEmpresaSeleccionada, // segueix disponible, però recomano usar selectEmpresa
        rolUsuari,
        setRolUsuari,
        usuariActiu,
        setUsuariActiu,
        esSuperUsuari,
        setEsSuperUsuari,
        NomUsuari,
        setNomUsuari,
        profileReady,
        setProfileReady,

        // helpers
        selectEmpresa,
        clearSession,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
